module.exports = __webpack_public_path__ + "assets/img/sliderItem1.e4db42af.png";